module.exports = __webpack_public_path__ + "static/aman-f42c8e219616a2239916f5dcca2360ab.png";